import { getInstance } from './authWrapper'
import jwt from 'jsonwebtoken'

    //ID list. If company rec id is not in this list we redirect to OneSignal
    const NON_REDIRECT_COMPANY_IDS = new Set([20822, 19998, 2, 16463])
    
    const REDIRECT_URL = 'https://onesignal.ccr.tv/'

    function clearClientSessionBeforeRedirect() {
      //Clear saved data on redirect
      document.cookie = 'savedUser=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      document.cookie = 'auth0.is.authenticated=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'

      
      const authPrefixes = ['@@auth0spajs@@', 'auth0', 'savedUser']
      Object.keys(localStorage).forEach((key) => {
        if (authPrefixes.some((prefix) => key.startsWith(prefix))) {
          localStorage.removeItem(key)
        }
      })

      Object.keys(sessionStorage).forEach((key) => {
        if (authPrefixes.some((prefix) => key.startsWith(prefix))) {
          sessionStorage.removeItem(key)
        }
      })
    }

    function getCompanyRecId(userDetails) {
      // console.log('Getting users Company_RecID and Contact_Company_RecID')
      //Get Company_RecID, fall back to Contact_Company_RecID
      const a = userDetails?.Company_RecID
      const b = userDetails?.Contact_Company_RecID
      return a ?? b ?? null
    }

    function redirectIfNeeded(companyRecId) {
      // console.log('Checking if user needs redirecting')
      if (!NON_REDIRECT_COMPANY_IDS.has(companyRecId)) {
        console.log('REDIRECTING TO ONESIGNAL')
        clearClientSessionBeforeRedirect()
        // This prevents returning to this exact entry
        window.location.replace(REDIRECT_URL)
        return true
      }
      return false
    }

export const authGuard = (to, from, next) => {
  const authService = getInstance()
  const url = to.name
  const fn = () => {
    // For testing expired token
    // if(authService.user) {
    //   authService.user.UserDetails.id_token = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IlEwSkRRelU1TmpZNU9VVTVPRVExT1VZM05UZzJSVE0wUkRReE0wSXdPREZDUVRCQlJETXlSZyJ9.eyJuaWNrbmFtZSI6eyJGaXJzdE5hbWUiOiJKb25hdGhvbiIsIkxhc3ROYW1lIjoiU2Nod2FtbWFuIiwiQ29udGFjdF9SZWNJRCI6NDM3MzUsIkNvbXBhbnlfUmVjSUQiOjIsIkNvbnRhY3RfQ29tcGFueV9SZWNJRCI6MiwiQ29tcGFueV9OYW1lIjoiQ0NSIiwiVGl0bGUiOiJEZXZlbG9wZXIifSwibmFtZSI6Impvbi5zY2h3YW1tYW5AY2NyLm5ldCIsInBpY3R1cmUiOiJodHRwczovL3MuZ3JhdmF0YXIuY29tL2F2YXRhci80YzU5YTY5NGYzMmRlY2NiZjkzMGIyZDFhYjE2YTNmOD9zPTQ4MCZyPXBnJmQ9aHR0cHMlM0ElMkYlMkZjZG4uYXV0aDAuY29tJTJGYXZhdGFycyUyRmpvLnBuZyIsInVwZGF0ZWRfYXQiOiIyMDIwLTA0LTA1VDE2OjQxOjIyLjU4N1oiLCJlbWFpbCI6Impvbi5zY2h3YW1tYW5AY2NyLm5ldCIsImlzcyI6Imh0dHBzOi8vbWFuYWdlMzYwLmF1dGgwLmNvbS8iLCJzdWIiOiJhdXRoMHxkOTkxMjNiNi1kNTE2LTQ5MzAtYTk1Yi00YjVkYjQzMjI3MjgiLCJhdWQiOiJaWnIwSXhBVXAxTlc5eTNsMGVDeGtaUUpWeGpGMHlXMiIsImlhdCI6MTU4NjE4MTkxMiwiZXhwIjoxNTg2MjE3OTEyLCJub25jZSI6IkJRQUtiY0VmWGhXMk5lRnl1QlNIclpNNUh5UTB3N2M0ZXh5aDFDOXlRY1oifQ.EU5rcHMM5VsvJesQDJhotF7VRM04teHFeEWrSZLaQsE_dghY6Icd-WPX_BE45zdHp6osv9QM9AuP6NoqfjmHTDWiy2mYhOYB7DZo5qVbO8Q4-Q5No4qzEXFtr8UUAGxgzPqYRZfRqorgNx1voxrgJFvXKA2OKDn5dF5fDxBhAEpo-hGV4Dz1_An3XhXgGRdHaQpQZa61h4_5N8xAilAtxY93XVDji-6wdk8AKteaTFqpdYKcF2Uh7qchYiLafir4hTRu-MRpfmmmYjR6ycYskeA09KcHv2OhOR3ZFtgiTXRVHl2Gbntaa9Jt_QWoBQrZoSxZHiy1fOFlARWD2g65lg';
    // }

    //if not authenticated, send user to Auth0.
    if (!authService.isAuthenticated) {
      // console.log('Not Auth. Redirecting to Auth0')
          return authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
        }
    const companyRecId = getCompanyRecId(authService.user.UserDetails)
    if (redirectIfNeeded(companyRecId)) {
      console.log('Redirecting....Stopping execution')
      return
    }
    const ACTIVE_COMPANY_ID = 2

    if (companyRecId !== ACTIVE_COMPANY_ID) {
      if (to.path !== '/site-inactive') {
        return next({ path: '/site-inactive', replace: true })
      }
      return next()
    }
    if (to.path === '/site-inactive') {
      return next('/home')
    }
    let token = authService.user
      ? jwt.decode(authService.user.UserDetails.id_token)
      : { exp: 0 }
    let currentTime = Math.floor(new Date().getTime() / 1000)

    if (token.exp < currentTime) {
      console.log('Logging Out')
      authService.logout({ returnTo: `${window.location.origin}` })
    }
    if (url == 'Channel Request' && authService.user.UserDetails.RoleID != 10) {
      return next('/unauthorized-access')
    }
    if (authService.isAuthenticated) {
      return next()
    }
    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
  }

  if (!authService.loading) {
    return fn()
  }

  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn()
    }
  })
}
